import { FEATURE_FLAGS, FeatureFlagName } from 'shared/feature-flags/flags';

/** Ручное значение флага, перекрывающее дату регистрации. */
export type FeatureFlagOverride = 'on' | 'off';

const isOverride = (value: string | null): value is FeatureFlagOverride => value === 'on' || value === 'off';

/**
 * Доступ к localStorage бросает в приватном режиме и при запрете сторонних данных,
 * поэтому каждое обращение обёрнуто: отсутствие override — рабочее состояние, а не ошибка.
 */
export const readOverride = (name: FeatureFlagName): FeatureFlagOverride | null => {
  try {
    const raw = localStorage.getItem(FEATURE_FLAGS[name].storageKey);

    return isOverride(raw) ? raw : null;
  } catch (err) {
    return null;
  }
};

export const writeOverride = (name: FeatureFlagName, value: FeatureFlagOverride): void => {
  try {
    localStorage.setItem(FEATURE_FLAGS[name].storageKey, value);
  } catch (err) {}
};

export const clearOverride = (name: FeatureFlagName): void => {
  try {
    localStorage.removeItem(FEATURE_FLAGS[name].storageKey);
  } catch (err) {}
};
